import 'react';
import { iArkStore } from '../../../state/store.js';
import { useUserOwnsEntry } from '../../hook.user-owns-entry.js';
import { TableCellInput } from './TableCellInput.js';
import { TableCellInputReadonly } from './TableCellInputReadonly.js';
import { TableCellText } from './TableCellText.js';
import { jsx } from 'react/jsx-runtime';

const TableCell = ({
  pageId,
  item,
  cell,
  sheetRef
}) => {
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const userOwnsEntry = useUserOwnsEntry(entryKey);
  if (cell.kind === "text") {
    return /*#__PURE__*/jsx(TableCellText, {
      cell: cell
    });
  }
  return userOwnsEntry ? /*#__PURE__*/jsx(TableCellInput, {
    pageId: pageId,
    itemId: item.id,
    cell: cell,
    sheetRef: sheetRef
  }) : /*#__PURE__*/jsx(TableCellInputReadonly, {
    pageId: pageId,
    itemId: item.id,
    cell: cell
  });
};

export { TableCell };
//# sourceMappingURL=TableCell.js.map
